import { forwardRef } from 'react';

import {
  _canReceiveDefaultTextFormat,
  type DataTestId,
  type StylingProps,
  type WithChildren,
} from '@dynatrace/strato-components/core';
import { Flex } from '@dynatrace/strato-components/layouts';
import { Text } from '@dynatrace/strato-components/typography';

//#region Typings
/**
 * Accepted properties for the HealthIndicator Label.
 * @public
 */
export interface HealthIndicatorLabelProps
  extends WithChildren,
    StylingProps,
    DataTestId {}
//#endregion

/**
 * The label of the HealthIndicator component.
 * @public
 */
export const Label = forwardRef<HTMLDivElement, HealthIndicatorLabelProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
      ...remainingProps
    }: HealthIndicatorLabelProps = props;
    const childIsText = _canReceiveDefaultTextFormat(children);

    return (
      <Flex
        data-testid={dataTestId}
        ref={forwardedRef}
        className={consumerClassName}
        style={consumerStyle}
        {...remainingProps}
      >
        {childIsText ? <Text>{children}</Text> : children}
      </Flex>
    );
  },
);

(Label as typeof Label & { displayName: string }).displayName =
  'HealthIndicator.Label';
